import React from "react";
import EvaEntityDetailContainer from "containers/eva/EvaEntityDetailContainer";

interface EvaEntityDetailPageProps {
  isSkillMode?: boolean;
}

const EvaEntityDetailPage: React.FC<EvaEntityDetailPageProps> = ({ isSkillMode = false }) => {
  return <EvaEntityDetailContainer isSkillMode={isSkillMode} />;
};

export default EvaEntityDetailPage;
